import React, { Component } from 'react';

const BASE = '/idea-bet.live/theme/1ufaai/';

const highlights = [
    'ฝาก-ถอน ออโต้ โปรแรงสุดในไทย',
    'อัพเกรดใหม่ ระบบไวกว่าเดิม',
    'ล็อคอินด้วยหมายเลขโทรศัพท์ ไม่ต้องจำยูส',
    'เดิมพันกีฬา ราคาดีที่สุด ค่าน้ำดี ค่าคอมสูง',
    'Live casino คาสิโนถ่ายทอดสด ทุกประเภท',
    'ปรับเปลี่ยนไม้ คาสิโน ได้ตามความต้องการ',
    'ระบบ ฝาก-ถอน รวดเร็ว ทันใจ ปลอดภัย 100%',
];

const cons = [
    'ต้องเสียเวลาจำยูสเซอร์',
    'แอดมินอ่านไม่ตอบ ไม่ใส่ใจ',
    'คอมมิชชั่นบางเป็นกระดาษ',
    'สมัครยาก เรื่องเยอะ ซ้ำซ้อน',
    'จำกัดวงเงินการถอนแต่ละครั้ง',
    'ฝากเงินแต่ละที เครดิตฟรีเข้าอีกวัน',
    'ยอดใหญ่ไม่ให้เล่น ยอดเล็กไม่ให้แทง',
    'ฝากเงินเล่นแบบเก่า เหมือนเต่าคลาน',
    'ไม่มั่นคง ถอนเงินเยอะ เบี้ยว ปิดเว็บหนี',
    'โปรโมชั่นคลุมเครือ เงื่อนไขเยอะ น่าเบื่อ',
    'ฝาก - ถอน ผ่านแอดมิน ยุ่งยาก รอนาน',
    'เว็บไซต์อื่นแค่หน้ากาก ทำธุรกรรมผ่านไลน์',
];

const pros = [
    'ลูกค้าสำคัญกว่าเอเย่นต์',
    'ยูฟ่า เว็บตรง ไม่ผ่านเอเย่นต์',
    'แทงบอลได้ไม่จำกัด ราคาดีที่สุด',
    'ค่าน้ำ/ค่าคอม สูงกว่าทุกเว็บในไทย',
    'ถอนได้ทุกวัน ไม่มีกำหนดสูงสุด',
    'เครดิตฟรีเข้าทันที ฝากปุ๊บ ได้เลย',
    'ปรับไม้ได้เอง ไม่ต้องผ่านแอดมิน',
    'ระบบทันสมัย ใช้งานง่าย สะดวกสบาย',
    'มั่นคง 100% จ่ายตรง ไม่เบี้ยว',
    'โปรโมชั่นชัดเจน เงื่อนไขน้อย คุ้มค่า',
    'ฝาก - ถอน ออโต้ รวดเร็วภายใน 1 นาที',
    'เว็บตรงจากบริษัทแม่ ปลอดภัย 100%',
];

const games = ['UFA', 'เซ็กซี่ บาคาร่า', 'SA บาคาร่า', 'สล็อตโจ๊กเกอร์', 'GD คาสิโน', 'มวยสเตป', 'หวยรายวัน', 'ยิงปลา', 'ไก่ชน', 'เกมส์ไฮโล'];

class ComparePage extends Component {
    render() {
        return (
            <div className="x-compare-container x-default-bg-center" style={{ paddingTop: '72px', minHeight: '100vh' }}>
                <link rel="stylesheet" href={BASE + 'style.css'} />

                <div className="container py-4">
                    <div className="text-center mb-5">
                        <h1 style={{ color: '#EFD0A0', fontSize: '24px', fontWeight: '700' }}>UFAgrand168 วันยูฟ่าน้ำดี คอม 0.7% ง่ายไม่ผ่านแอดมิน</h1>
                    </div>

                    {/* Highlights */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '10px', marginBottom: '32px' }}>
                        {highlights.map((h, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(184,150,46,0.15)', border: '1px solid #b8962e', borderRadius: '8px', padding: '12px 14px' }}>
                                <span style={{ color: '#EFD0A0', fontSize: '16px' }}>✓</span>
                                <span style={{ color: '#fff', fontSize: '13px' }}>{h}</span>
                            </div>
                        ))}
                    </div>

                    {/* Compare table */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '32px' }}>
                        <div style={{ border: '1px solid #555', borderRadius: '12px', padding: '20px', background: 'rgba(0,0,0,0.5)' }}>
                            <h3 style={{ color: '#f66', textAlign: 'center', marginBottom: '16px', fontSize: '16px' }}>❌ เว็บเอเย่นต์แบบเดิม ๆ</h3>
                            {cons.map((c, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', marginBottom: '8px' }}>
                                    <span style={{ color: '#f66', fontSize: '13px', flexShrink: 0 }}>✗</span>
                                    <span style={{ color: '#ccc', fontSize: '13px', lineHeight: '1.5' }}>{c}</span>
                                </div>
                            ))}
                        </div>
                        <div style={{ border: '1px solid #b8962e', borderRadius: '12px', padding: '20px', background: 'rgba(184,150,46,0.1)' }}>
                            <h3 style={{ color: '#EFD0A0', textAlign: 'center', marginBottom: '16px', fontSize: '16px' }}>✅ UFAgrand168 เว็บตรงยูฟ่า</h3>
                            {pros.map((p, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', marginBottom: '8px' }}>
                                    <span style={{ color: '#4caf50', fontSize: '13px', flexShrink: 0 }}>✓</span>
                                    <span style={{ color: '#fff', fontSize: '13px', lineHeight: '1.5' }}>{p}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Games */}
                    <div style={{ border: '1px solid #b8962e', borderRadius: '12px', padding: '20px', background: 'rgba(0,0,0,0.3)' }}>
                        <h3 style={{ color: '#EFD0A0', marginBottom: '14px', fontSize: '16px', textAlign: 'center' }}>เกมที่ให้บริการใน UFAgrand168</h3>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
                            {games.map((g, i) => (
                                <span key={i} style={{ background: 'linear-gradient(rgb(231,211,157), rgb(177,149,96))', color: '#333', borderRadius: '20px', padding: '5px 16px', fontSize: '13px', fontWeight: '600' }}>{g}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ComparePage;
